<template>
  <div id="app">
    <!-- Login page sans sidebar -->
    <div v-if="$route.name === 'Login'" class="login-container">
      <router-view />
    </div>

    <!-- Application principale avec sidebar -->
    <div v-else class="app-container" :class="{ 'nav-open': navOpen }">
      <!-- Barre supérieure : visible uniquement sous 992px -->
      <header class="mobile-topbar">
        <button
          type="button"
          class="nav-toggle"
          :aria-expanded="navOpen ? 'true' : 'false'"
          aria-controls="app-sidebar"
          :aria-label="navOpen ? 'Fermer le menu' : 'Ouvrir le menu'"
          @click="navOpen = !navOpen"
        >
          <i :class="navOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
        </button>
        <router-link to="/" class="topbar-brand" aria-label="Accueil DMS">
          <img src="/images/logo.png" alt="DMS" class="topbar-logo">
        </router-link>
        <span class="topbar-title">{{ pageTitle }}</span>
      </header>

      <div class="nav-backdrop" aria-hidden="true" @click="navOpen = false"></div>

      <Sidebar id="app-sidebar" :class="{ show: navOpen }" />
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

const TITLES = {
  Dashboard: 'Dashboard',
  Emails: 'Messages',
  Commandes: 'Commandes',
  Customers: 'Clients',
  Produits: 'Produits',
  Transporteurs: 'Transporteurs',
  EmailAccounts: 'Comptes mail',
  Chat: 'Assistance IA',
  About: 'À propos',
  Analytics: 'Analytics',
  NotificationChannels: 'Notifications',
  OrganisationSettings: 'Settings'
}

export default {
  name: 'App',
  components: {
    Sidebar
  },
  data() {
    return { navOpen: false }
  },
  computed: {
    pageTitle() {
      return TITLES[this.$route.name] || 'DMS'
    }
  },
  watch: {
    // Referme le tiroir après chaque navigation
    '$route.fullPath'() {
      this.navOpen = false
    },
    navOpen(open) {
      document.body.classList.toggle('nav-locked', open)
    }
  },
  mounted() {
    this.onKey = (e) => { if (e.key === 'Escape') this.navOpen = false }
    window.addEventListener('keydown', this.onKey)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKey)
    document.body.classList.remove('nav-locked')
  }
}
</script>

<style>
.login-container {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
